import { FC, HTMLAttributes } from 'react';
import { merge } from '../../utils/utility';

interface CardDividerProps extends HTMLAttributes<HTMLDivElement> {}

export const CardDivider: FC<CardDividerProps> = ({ className }) => {
  return <div className={merge(className, 'border-b border')}></div>;
};
